module.exports = __webpack_public_path__ + "fonts/Gotham-Bold.925608f9.ttf";